var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardAdvancedsearchAllrecordsListOomIcon = function SvgNewcsDashboardAdvancedsearchAllrecordsListOomIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_advancedsearch_allrecords_list_oom_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z",
    "data-name": "\\u77E9\\u5F62 426"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_advancedsearch_allrecords_list_oom_icon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3.851.839h.008a3.02 3.02 0 0 1 3 3v.017a3.02 3.02 0 0 1-3 3h-.017a3.02 3.02 0 0 1-3-3v-.014l.015-.295a3.2 3.2 0 0 1 .218-.853 3.1 3.1 0 0 1 .875-1.171 3.05 3.05 0 0 1 1.9-.684ZM3.85 0a3.9 3.9 0 0 0-2.436.875A3.97 3.97 0 0 0 .3 2.37a4 4 0 0 0-.281 1.094L0 3.84v.022A3.86 3.86 0 0 0 3.828 7.7h.045A3.857 3.857 0 0 0 7.7 3.862V3.84A3.86 3.86 0 0 0 3.868 0Z",
    "data-name": "\\u8DEF\\u5F84 442"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_advancedsearch_allrecords_list_oom_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    d: "M2.408 14.304a1.4 1.4 0 0 1-1.4-1.4v-9.8a1.4 1.4 0 0 1 1.4-1.4h11.2a1.4 1.4 0 0 1 1.4 1.4v9.8a1.4 1.4 0 0 1-1.4 1.4Zm-.352-1.4a.35.35 0 0 0 .349.35h11.2a.35.35 0 0 0 .349-.35v-8.4h-11.9Zm2.454-9.8a.7.7 0 0 0 .7.7.7.7 0 0 0 .7-.7.7.7 0 0 0-.7-.7.7.7 0 0 0-.702.7Zm-2.1 0a.7.7 0 0 0 .7.7.7.7 0 0 0 .7-.7.7.7 0 0 0-.7-.7.7.7 0 0 0-.702.7Zm5.587 6.12-1.436 1.392-.314-.411 1.38-1.337-1.4-1.335.3-.392 1.446 1.381 1.5-1.453.314.413-1.443 1.4 1.427 1.361-.3.391Z",
    "data-name": "\\u8054\\u5408 39"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_advancedsearch_allrecords_list_oom_icon_svg__b)",
    "data-name": "\\u7EC4 17",
    transform: "translate(4.15 5)"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAICAYAAAArzdW1AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACYSURBVChTVY9BCsIwEEUnRYtgFQ/gFbyWUg9UcOOJBBceQBAXLlzorrba+H7SQPvh8f9MJ5PUvPeBbdnlkPX5A+/0LTO02/s55pR7dXCjf1LhNEmxJDeHytVqSvQu2BXqsAlpSx5jFAc2WAuP4dAsxpHO8E1Doy0DPeGV3rSm0IEV6CfkBSy49hg2Ee6YrpvAVD30g8bM7A9nHD0J8c9pfQAAAABJRU5ErkJggg==",
    width: 8.977,
    height: 7.979,
    "data-name": "\\u77E9\\u5F62 519",
    transform: "translate(-.999 -.289)"
  })))));
};
export default SvgNewcsDashboardAdvancedsearchAllrecordsListOomIcon;